export default {
  data() {
    return {
      tableData: [],
      columns: [{
        slots: {
          title: '消息名称'
        },
        dataIndex: 'orderNo',
        key: '1'
      }, {
        slots: {
          title: '时间'
        },
        dataIndex: 'appName',
        key: '2',
        width: 300
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {},
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};